export default "__VITE_ASSET__CZKV68do__"